import { cn } from "../../helpers"
import { paragraph, title as titleStyle } from "../typography"

const root = cn("flex flex-col items-left gap-2 lg:gap-6 md:inline")

const wrapper = cn("flex flex-col items-left gap-2")
const title = (className?: string) =>
  cn(
    titleStyle({
      size: "sm",
      className: "text-left md:text-center md:text-2xl",
    }),
    className
  )
const description = (descriptionSize: "sm" | "md" = "md") =>
  cn(
    paragraph({
      size: descriptionSize,
      className: "text-neutral-700 text-left md:text-center text-sm md:text-base",
    })
  )

export { description, root, title, wrapper }
